import { render, staticRenderFns } from "./InsNavLayout.vue?vue&type=template&id=36fefe7c&scoped=true"
import script from "./InsNavLayout.vue?vue&type=script&lang=ts"
export * from "./InsNavLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsNavLayout.vue?vue&type=style&index=0&id=36fefe7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fefe7c",
  null
  
)

export default component.exports